import React, { useState } from 'react'
import favicon from "../assets/favicon.png"
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { reSendMobileOTP, verifyMobileOTPAPI } from '../utils/api';
import loadingif from "../assets/loading-gif.gif";

const MobileOTP = () => {
    const [mobileotp, setMobileOTP] = useState("");
    const mobile = localStorage.getItem("hrmobile");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const NumericOnly = (e) => {
        const reg = /^[0-9\b]+$/
        let preval = e.target.value
        if (e.target.value === '' || reg.test(e.target.value)) setMobileOTP(e.target.value)
        else e.target.value = preval.substring(0, (preval.length - 1))
    }
    const handleOTPSubmit = async (e) => {
        e.preventDefault();
        if (mobileotp.length === 4) {
            setLoading(true);
            const mobiledata = {
                mobile,
                mobileotp,
            };
            verifyMobileOTPAPI("hr-verify-mobile-otp", mobiledata).then((res) => {
                if (res.data.status === 1) {
                    localStorage.setItem("hrdata", res.data.data);
                    toast.success(res.data.msg);
                    setLoading(false);
                    navigate("/dashboard");
                }
                else {
                    setLoading(false);
                    toast.error(res.data.msg);
                }
            })
        }
        else {
            toast.error("Invalid Mobile OTP!!");
        }
    }
    const resendMobileOTP = () => {
        if (mobile.length === 10) {
            reSendMobileOTP("hr-resend-mobile-otp", mobile).then((res) => {
                if (res.data.status === 1) {
                    toast.success("Mobile OTP has been send!!")
                }
                else {
                    toast.error("Check you connection!!")
                }
            })
        }
        else {
            toast.error("Invalid Mobile Number!!");
        }
    }
    return (
        <div className="homePage">
            <Helmet>
                <title>SATKARTAR:MOBILE OTP</title>
            </Helmet>
            <div className="container h-100">
                <div className="d-flex justify-content-center h-100">
                    <div className="user_card">
                        <div className="d-flex justify-content-center">
                            <div className="brand_logo_container">
                                <img src={favicon} className="brand_logo" alt="Logo" />
                            </div>
                            <h1 className="loginnames">HR LOGIN</h1>
                        </div>
                        <div className="d-flex justify-content-center form_container">
                            <form method="POST" onSubmit={handleOTPSubmit}>
                                <div className="form-group">
                                    <label htmlFor="hr_mobile_otp">Enter Mobile OTP</label>
                                    <input type="text" name="hr_mobile_otp" className="form-control input_user" id="hr_mobile_otp" placeholder="Enter the Mobile OTP" required={true} maxLength={6} onChange={NumericOnly} />
                                </div>
                                <div className="d-flex justify-content-center mt-3 login_container">
                                    {loading ?
                                        <button disabled={true} type="submit" className="btn login_btn">
                                            <img src={loadingif} alt={loadingif} style={{ width: "7%", marginTop: "-3px" }} /> VERIFY OTP...
                                        </button>
                                        :
                                        <button type="submit" className="btn login_btn">LOGIN</button>
                                    }
                                </div>
                                <div className="d-flex justify-content-end login_container">
                                    <span className="reSendMobileOTP" onClick={resendMobileOTP}>Re-Send Mobile OTP</span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobileOTP
